export enum LOGIN_FORM_OPTIONS {
  LOGIN = 'login',
  REGISTER = 'register',
  RESET_PASSWORD = 'resetPassword',
}
